import {
  TICKET_NEW, TICKET_LIST, TICKET_VIEW, TICKET_REPLY
} from '@store/endpoints.js'
import { STORE_TICKET, STORE_TICKETS } from '../mutation-types'
export async function createTicket ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: TICKET_NEW,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function fetchTickets ({ commit }, payload) {
  try {
    const response = await this.$api.get({
      url: TICKET_LIST,
      query: { section: payload }
    })
    if (response && response?.data) {
      return response.data.tickets
    }
  } catch (e) {
  }
}
export async function asyncTicket ({ commit }, payload) {
  const { data } = await this.$api.get({
    url: TICKET_VIEW + payload
  })
  commit(STORE_TICKET, data)
}
export async function asyncTicketList ({ commit }, payload) {
  const response = await this.$api.get({
    url: TICKET_LIST,
    query: { section: payload }
  })

  if (response && response?.data) {
    commit(STORE_TICKETS, response.data)
  }
}
export async function replyTicket ({ commit }, payload) {
  try {
    const response = await this.$api.post({
      url: TICKET_REPLY,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
